import React from 'react';
import {injectIntl} from 'react-intl';
import propTypes from 'prop-types';
import {Button, Grid} from '@mui/material';
import {Offer as GenericOffer} from 'wobi-web-common';
import useStyles from './useStyles';

const Offer = (props) => {
  const {data, setIsOpen, creditCardCommission, creditCardCommissionDiscount, logo, fireDetailsEvent} = props;
  const { classes } = useStyles({isMobile: true,
    isOpen: false});
  const messages = (id) => props.intl.formatMessage({id});
  const {
    providerName,
    productLineName,
    price,
    priceAfterDiscount,
  } = data;

  const handleClickOnDetails = () => {
    setIsOpen(true);
    fireDetailsEvent();
  };

  return (
    <GenericOffer {...props}>
      <div
        role='button'
        tabIndex={0}
        className={[classes.offerContent, classes.offerContentClosed].join(' ')}
        onClick={() => setIsOpen(true)}
        onKeyPress={() => setIsOpen(true)}
      >
        <div className={[classes.logo, classes.logoClosed].join(' ')}>
          <img
            src={logo ? logo.imgSrc_big : ''}
            alt={`חברת ${providerName}`}
          />
          <b>{productLineName}</b>
        </div>
        <div className={[classes.left, classes.leftClosed].join(' ')}>
          <Grid
            container
            style={{position: 'relative'}}
            spacing={0}
            justifyContent='flex-start'
          >
            <Grid size={6}>
              {priceAfterDiscount ? (
                <Grid
                  container
                  style={{position: 'relative'}}
                  spacing={0}
                  justifyContent='space-between'
                  size={6}>
                  <Grid items className={classes.pricesWrapDiscount} size={3}>
                    <div className={[classes.prices, classes.pricesClosed].join(' ')}>
                      <div className={[classes.totalPrice, classes.totalPriceClosedDiscount].join(' ')}>
                        <span>₪</span>
                        { Math.round(creditCardCommissionDiscount + priceAfterDiscount).toLocaleString() }
                      </div>
                    </div>
                  </Grid>
                  <Grid items className={classes.pricesWrapDiscount} size={3}>
                    <div className={[classes.prices, classes.pricesClosed].join(' ')}>
                      <div
                        className={[classes.totalPrice,
                          classes.totalPriceClosedDiscount,
                          classes.totalPriceCrossedClosed].join(' ')}
                      >
                        <span>₪</span>
                        { Math.round(creditCardCommission + price).toLocaleString() }
                      </div>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <div className={classes.pricesWrap}>
                  <div className={[classes.prices, classes.pricesClosed].join(' ')}>
                    <div className={[classes.totalPrice, classes.totalPriceClosed].join(' ')}>
                      <span>₪</span>
                      { Math.round(creditCardCommission + price).toLocaleString() }
                    </div>
                  </div>
                </div>
              )}
            </Grid>
            <Grid className={classes.purchaseBtnWrapper} size={6}>
              <Button
                onClick={handleClickOnDetails}
                color='secondary'
                variant='outlined'
                className={classes.purchaseBtn}
              >
                {messages('offers.purchase')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </GenericOffer>
  );
};

Offer.propTypes = {
  ...GenericOffer.propTypes,
  closeContactUsHandler: propTypes.func.isRequired,
  openContactUs: propTypes.func.isRequired,
};

export default injectIntl(Offer);
